export const wiki = {
  wiki: 'Wiki',
  homeH1: 'Wiki de skins de CS2',
  homeSubtitle: 'Todos los skins de CS2: desgaste, rareza, cajas y colecciones',
  categoriesTitle: 'Categorías',
  featuredTitle: 'Skins explicados',
  allWeaponsTitle: 'Todas las armas',
  aboutWiki: 'Sobre la wiki',
  readMore: 'Leer más',
  showAll: 'Ver los {{count}}',
  floatScaleLabel: 'Escala de float de 0 a 1 y el desgaste de cada rango',
  searchPlaceholder: 'Busca un skin, un arma o una caja',
  searchPlaceholderShort: 'Skin, arma o caja',
  searchSubmit: 'Buscar',
  searchClear: 'Borrar búsqueda',
  searchH1: 'Buscar en la wiki',
  searchResultsFor: 'Resultados para “{{q}}”',
  searchEmptyTitle: 'No se encontró nada',
  searchEmptyText: 'Revisa la ortografía o prueba con el nombre en inglés.',
  searchEmptyTextLatin: 'Revisa la ortografía o acorta la búsqueda.',
  searchOpenCatalog: 'Abrir el catálogo',
  searchErrorTitle: 'No se cargó la búsqueda',
  searchErrorText: 'Revisa tu conexión y busca de nuevo.',
  searchShortQuery: 'Escribe al menos dos caracteres.',
  retry: 'Reintentar',
  suggestEmpty: 'Sin coincidencias',
  suggestAll: 'Ver todos los resultados',
  typeSkin: 'Skin',
  typeWeapon: 'Arma',
  typeContainer: 'Caja',
  typeCollection: 'Colección',
  catPistols: 'Pistolas',
  catRifles: 'Rifles',
  catSmgs: 'Subfusiles',
  catHeavy: 'Armas pesadas',
  catKnives: 'Cuchillos',
  catGloves: 'Guantes',
  catEquipment: 'Equipo',
  weaponsTitle: 'Armas',
  modelsTitle: 'Modelos',
  selectionsTitle: 'Selecciones',
  guidesTitle: 'Guías',
  containersTitle: 'Últimas cajas',
  allSkins: 'Todos los skins',
  allGuides: 'Todas las guías',
  allSelections: 'Todas las selecciones',
  allCases: 'Todas las cajas',
  allCollections: 'Todas las colecciones',
  skinsOne: '{{count}} skin',
  skinsFew: '{{count}} skins',
  skinsMany: '{{count}} skins',
  knivesOne: '{{count}} cuchillo',
  knivesFew: '{{count}} cuchillos',
  knivesMany: '{{count}} cuchillos',
  glovesOne: '{{count}} par de guantes',
  glovesFew: '{{count}} pares de guantes',
  glovesMany: '{{count}} pares de guantes',
  rareItemsOne: '{{count}} objeto',
  rareItemsFew: '{{count}} objetos',
  rareItemsMany: '{{count}} objetos',
  skinsPlusRare: '{{skins}} + {{rare}}',
  catalogH1: 'Skins de CS2',
  catalogCategoryH1: 'Skins de CS2: {{category}}',
  filtersTitle: 'Filtros',
  filterWeapon: 'Arma',
  filterRarity: 'Rareza',
  filterCollection: 'Colección',
  filterCase: 'Caja',
  filterExterior: 'Desgaste',
  filterStatTrak: 'Con StatTrak™',
  filterSouvenir: 'Con Recuerdo',
  anyWeapon: 'Cualquier arma',
  anyRarity: 'Cualquier rareza',
  anyCollection: 'Cualquier colección',
  anyCase: 'Cualquier caja',
  removeFilter: 'Quitar el filtro “{{name}}”',
  sortLabel: 'Ordenar',
  sortRarity: 'Por rareza',
  sortName: 'Por nombre',
  sortRelease: 'Más nuevos primero',
  sortPrice: 'Por precio',
  applyFilters: 'Mostrar',
  resetFilters: 'Restablecer filtros',
  resetShort: 'Restablecer',
  closeFilters: 'Cerrar filtros',
  catalogEmptyTitle: 'Ningún skin coincide con estos filtros',
  catalogEmptyText: 'Quita algunos filtros o restablécelos todos.',
  prevPage: 'Anterior',
  nextPage: 'Siguiente',
  pageOf: 'Página {{page}} de {{count}}',
  foundCount: 'Encontradas: {{count}}',
  foundCountMasculine: 'Encontrados: {{count}}',
  priceFrom: 'desde {{price}}',
  weaponAllFilters: 'Todos los filtros en el catálogo',
  breadcrumbs: 'Ruta de navegación',
  exteriorFn: 'Recién fabricado',
  exteriorMw: 'Casi nuevo',
  exteriorFt: 'Algo desgastado',
  exteriorWw: 'Bastante desgastado',
  exteriorBs: 'Deplorable',
  kindNormal: 'Normal',
  kindStatTrak: 'StatTrak™',
  kindSouvenir: 'Recuerdo',
  vanillaFinish: 'Vanilla',
  phasesTitle: 'Fases',
  statsTitle: 'Detalles',
  statWeapon: 'Arma',
  statFinish: 'Acabado',
  statRarity: 'Rareza',
  statFloat: 'Rango de float',
  statExteriors: 'Desgastes',
  statKinds: 'Versiones',
  statCollections: 'Colección',
  statContainers: 'Cajas',
  statRelease: 'Año de lanzamiento',
  rareItem: 'objeto especial raro',
  rareDropNote: 'Sale como objeto especial raro ★',
  pricesTitle: 'Precios de Steam',
  pricesHint: 'Precio en el Mercado de la Comunidad de Steam, en dólares estadounidenses.',
  priceAsOf: 'Actualizado el {{date}}.',
  noPrice: 'Sin datos actuales',
  noPriceMarked: 'Sin datos actuales para las versiones marcadas',
  gameDescriptionTitle: 'Descripción del juego',
  faqTitle: 'Preguntas frecuentes',
  similarTitle: 'Skins similares',
  shotTitle: 'Disponible en SHOT',
  shotHint: 'Este skin está en estas cajas de SHOT.',
  dropsTitle: 'Últimos drops',
  dropsHint: 'Quién lo sacó en SHOT y dónde.',
  dropsCase: 'Caja “{{name}}”',
  dropsCaseBattle: 'Case Battles',
  dropsUpgrade: 'Upgrade',
  dropsContract: 'Contratos',
  dropsRushMid: 'Rush Mid',
  dropsRoulette: 'Ruleta rusa',
  timeJustNow: 'ahora mismo',
  timeMinutesAgo: 'hace {{count}} min',
  timeHoursAgo: 'hace {{count}} h',
  timeDaysAgo: 'hace {{count}} d',
  englishName: 'Nombre en inglés',
  caseReleased: 'Lanzada en {{year}}',
  rareTitle: 'Objetos especiales raros',
  compositionTitle: 'Skins incluidos',
  rareHintKnives: 'Los cuchillos salen de esta caja como un objeto especial raro aparte.',
  rareHintGloves: 'Los guantes salen de esta caja como un objeto especial raro aparte.',
  rareHintKnivesAndGloves: 'Los cuchillos y los guantes salen de esta caja como un objeto especial raro aparte.',
  rareKnives: 'cuchillos',
  rareGloves: 'guantes',
  rareKnivesAndGloves: 'cuchillos y guantes',
  caseCollectionTitle: 'Colección de la caja',
  collectionCasesTitle: 'Cajas con esta colección',
  collectionReleased: 'Lanzada en {{year}}',
  tocTitle: 'Contenido',
  reviewedOn: 'Revisado el {{date}}',
  reviewedBy: 'Revisado por el equipo de SHOT · {{date}}',
  shortAnswer: 'Respuesta corta',
  guidesH1: 'Guías de skins de CS2',
  selectionsH1: 'Selecciones de skins de CS2',
  casesH1: 'Cajas de CS2',
  collectionsH1: 'Colecciones de CS2',
  weaponSkinsH1: 'Skins de {{weapon}}',
};

export const wikiItem = {
  typeSticker: 'Pegatina',
  typeAgent: 'Agente',
  typeCharm: 'Colgante',
  typeMusicKit: 'Kit de música',
  typePatch: 'Parche',
  typeGraffiti: 'Grafiti',
  typePin: 'Pin',
  sectionStickers: 'Pegatinas',
  sectionAgents: 'Agentes',
  sectionCharms: 'Colgantes',
  sectionMusicKits: 'Kits de música',
  sectionPatches: 'Parches',
  sectionGraffiti: 'Grafitis',
  sectionPins: 'Pins',
  kindCase: 'Caja',
  kindStickerCapsule: 'Cápsula de pegatinas',
  kindAutographCapsule: 'Cápsula de autógrafos',
  kindSouvenirPackage: 'Paquete de recuerdos',
  kindMusicKitBox: 'Caja de kits de música',
  kindPatchCapsule: 'Paquete de parches',
  kindPinsCapsule: 'Cápsula de pins',
  kindGraffitiBox: 'Caja de grafitis',
  tabAll: 'Todo',
  tabCases: 'Cajas',
  tabStickerCapsules: 'Cápsulas de pegatinas',
  tabAutographCapsules: 'Cápsulas de autógrafos',
  tabSouvenirPackages: 'Paquetes de recuerdos',
  tabMusicKitBoxes: 'Cajas de kits de música',
  tabPatchCapsules: 'Paquetes de parches',
  tabPinsCapsules: 'Cápsulas de pins',
  tabGraffitiBoxes: 'Cajas de grafitis',
  kindsNavLabel: 'Tipos de contenedores',
  containersH1: 'Cajas y cápsulas de CS2',
  h1StickerCapsules: 'Cápsulas de pegatinas de CS2',
  h1AutographCapsules: 'Cápsulas de autógrafos de CS2',
  h1SouvenirPackages: 'Paquetes de recuerdos de CS2',
  h1MusicKitBoxes: 'Cajas de kits de música de CS2',
  h1PatchCapsules: 'Paquetes de parches de CS2',
  h1PinsCapsules: 'Cápsulas de pins de CS2',
  h1GraffitiBoxes: 'Cajas de grafitis de CS2',
  stickersOne: '{{count}} pegatina',
  stickersFew: '{{count}} pegatinas',
  stickersMany: '{{count}} pegatinas',
  musicKitsOne: '{{count}} kit de música',
  musicKitsFew: '{{count}} kits de música',
  musicKitsMany: '{{count}} kits de música',
  patchesOne: '{{count}} parche',
  patchesFew: '{{count}} parches',
  patchesMany: '{{count}} parches',
  pinsOne: '{{count}} pin',
  pinsFew: '{{count}} pins',
  pinsMany: '{{count}} pins',
  graffitiOne: '{{count}} grafiti',
  graffitiFew: '{{count}} grafitis',
  graffitiMany: '{{count}} grafitis',
  colorsOne: '{{count}} color',
  colorsFew: '{{count}} colores',
  colorsMany: '{{count}} colores',
  inGameSince: 'En el juego desde {{year}}',
  contentsTitle: 'Qué contiene',
  variantsTitle: 'Variantes',
  groupSticker: 'Pegatina',
  groupSlab: 'En una lámina',
  effectPaper: 'Papel',
  effectHolo: 'Holo',
  effectFoil: 'Metalizada',
  effectGold: 'Dorada',
  effectGlitter: 'Purpurina',
  effectLenticular: 'Lenticular',
  effectEmbroidered: 'Bordada',
  stickerAutograph: 'Autógrafo',
  stickerTeam: 'Equipo',
  stickerEvent: 'Torneo',
  stickerOther: 'Otras',
  sideT: 'Terroristas',
  sideCt: 'Antiterroristas',
  statType: 'Tipo',
  statStickerKind: 'Tipo de pegatina',
  statTournament: 'Torneo',
  statTeam: 'Equipo',
  statPlayer: 'Jugador',
  statEffects: 'Efectos',
  statSlab: 'En una lámina',
  statSide: 'Bando',
  statArtist: 'Artista',
  statStatTrak: 'StatTrak™',
  statColors: 'Colores',
  valueYes: 'Disponible',
  valueNo: 'No disponible',
  whereTitle: 'Dónde conseguirlo',
  whereCollection: 'Colección',
  whereStickerPack: 'Paquete de pegatinas',
  shotHintItem: 'Este objeto sale de estas cajas de SHOT.',
  souvenirPackagesRow: 'Paquetes de recuerdos',
  moreCount: '{{count}} más',
  typeHighlight: 'Colgante de momento destacado',
  typePass: 'Pase',
  typeKey: 'Llave',
  sectionHighlights: 'Colgantes de momentos destacados',
  sectionPasses: 'Pases',
  sectionKeys: 'Llaves',
  kindOther: 'Paquete',
  tabOther: 'Otros',
  h1Other: 'Otros paquetes de CS2',
  itemsOne: '{{count}} objeto',
  itemsFew: '{{count}} objetos',
  itemsMany: '{{count}} objetos',
  statEvent: 'Torneo',
  statStage: 'Fase',
  statMap: 'Mapa',
  statTeams: 'Partida',
  statVideo: 'Vídeo',
  watchVideo: 'Ver el momento',
  statOpens: 'Se abre con',
  listH1Stickers: 'Pegatinas de CS2',
  listH1Agents: 'Agentes de CS2',
  listH1Charms: 'Colgantes de CS2',
  listH1MusicKits: 'Kits de música de CS2',
  listH1Patches: 'Parches de CS2',
  listH1Graffiti: 'Grafitis de CS2',
  listH1Highlights: 'Colgantes de momentos destacados de CS2',
  listH1Pins: 'Pins de CS2',
  listH1Passes: 'Pases de CS2',
  listH1Keys: 'Llaves de cajas de CS2',
  listCount: '{{count}} en el juego',
  typeCollectible: 'Coleccionable',
  sectionCollectibles: 'Monedas, medallas y trofeos',
  listH1Collectibles: 'Monedas, medallas y trofeos de CS2',
  collectibleCoin: 'Moneda',
  collectibleTrophy: 'Trofeo',
  collectibleMedal: 'Medalla',
  versionNumber: 'Versión {{n}}',
  allItemsTitle: 'Todos los objetos',
  sectionContainers: 'Cajas y cápsulas',
};
